import { Link } from 'react-router-dom';
import { Collapse, Layout, Typography } from 'antd';
import styled from 'styled-components';

export const FooterStyled = styled(Layout.Footer)`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 120px;
	padding: 0;
	border-top: 1px solid #f5f5f5;
	background-color: #fafafa;
	@media (max-width: 575px) {
		margin-top: 60px;
	}
`;

export const MobileFooterHeadingStyled = styled.h3`
	margin: 0;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
`;

export const FooterContentStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 668px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
		display: block;
	}
`;
export const FooterContentTabletStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 668px;
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
		display: none;
	}
`;
export const FooterContentMobileStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
		display: block;
		margin: 0 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		display: none;
		margin: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
		display: none;
	}
`;

export const FooterContentUpperStyled = styled(`div`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: flex;
		flex-direction: column;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: flex;
		gap: 30px;
		justify-items: start;
		width: 496px;
		grid-template-columns: 1fr 1fr;
		padding: 45px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: grid;
		column-gap: 24px;
		justify-items: start;
		width: 688px;
		grid-template-columns: 1fr 1fr;
		padding: 45px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 916px;
		padding: 45px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 1200px;
		padding: 50px 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 1200px;
		padding: 50px 0;
	}
`;
export const FooterContentLowerStyled = styled(`div`)`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px 0;
	border-top: 1px solid #f5f5f5;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
`;
export const FooterContentUpperItemStyled = styled(`div`)``;
export const FooterContentUpperItemLastStyled = styled(`div`)`
	width: 282px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		grid-column: 2;
		margin-left: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		grid-column: 3;
		margin-left: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		grid-column: 3;
		margin-left: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		grid-column: 9;
		margin-left: 0;
	}
`;

export const LanguagePickerContainerStyled = styled.div`
	position: absolute;
	left: 0;
`;

export const FooterHeaderStyled = styled(`h3`)`
	font-weight: 600;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		margin-bottom: 20px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
		margin-bottom: 20px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 20px;
		margin-bottom: 20px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 20px;
		margin-bottom: 20px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 20px;
		margin-bottom: 20px;
	}
`;

export const FooterLinksContainerStyled = styled(`div`)`
	gap: 20px;
	display: flex;
	flex-direction: column;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		gap: 10px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		margin-left: 0;
		gap: 10px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		margin-left: 0;
		gap: 10px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		margin-left: 0;
		gap: 10px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin-left: 0;
		gap: 10px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		margin-left: 0;
		gap: 10px;
	}
`;
export const FooterLinksContainerLastStyled = styled(`div`)`
	gap: 20px;
	display: flex;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		flex-direction: column;
		margin-left: 0;
		margin-bottom: 0;
		gap: 15px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		flex-direction: column;
		margin-left: 0;
		margin-bottom: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		flex-direction: column;
		margin-left: 0;
		margin-bottom: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		flex-direction: column;
		margin-left: 0;
		margin-bottom: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: column;
		margin-left: 0;
		margin-bottom: 0;
		gap: 20px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		flex-direction: column;
		grid-column: 6;
		margin-bottom: 0;
		gap: 20px;
	}
`;

export const FooterContactsContainerStyled = styled(`div`)`
	gap: 12px;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: row;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		flex-direction: row;
	}
`;

export const FooterEmailStyled = styled(`div`)`
	gap: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 15px;
	height: 42px;
	border: 1px solid #1890ff;
`;

export const FooterTelegramStyled = styled(`div`)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 42px;
	height: 42px;
	background-color: #1890ff;
`;

export const FooterEmailTextStyled = styled(`p`)`
	margin: 0;
	font-size: 16px;
`;

export const FooterTextStyled = styled(`p`)`
	margin: 0;
	color: #8c8c8c;
	font-weight: 300;
	font-size: 16px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
`;

export const FooterLink = styled(Typography.Link)`
	color: #000 !important;
	font-weight: 300;
	font-size: 16px;
	&:hover {
		color: #1890ff !important;
	}
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;
export const FooterRouteLink = styled(Link)`
	color: #000 !important;
	font-weight: 300;
	font-size: 16px;
	&:hover {
		color: #1890ff !important;
	}
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 16px;
	}
`;

export const FooterLogoStyled = styled(`div`)`
	margin-top: 3px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		padding: 25px 0 13px 0;
		margin: 0;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		padding: 20px 0 0 0;
		margin: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		padding: 20px 0 0 0;
		margin: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		padding: 20px 0 0 0;
		margin: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		margin-top: 3px;
		padding: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		margin-top: 3px;
		padding: 0;
	}
`;

export const FooterBottomStyled = styled(`div`)`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px 0;
	width: 100%;
	border-top: 1px solid #f5f5f5;
`;

export const FooterLogoMStyled = styled(`div`)`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 25px;
`;

export const FooterContentUpperMStyled = styled(Collapse)`
	display: flex;
	flex-direction: column;
	margin-top: 24px;
	margin-bottom: 40px;
	border-bottom: 1px solid #f0f0f0;
`;

export const FooterContentUpperItemMStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
`;

export const FooterHeaderMStyled = styled(`h3`)`
	margin-bottom: 16px;
`;

export const FooterBottomMStyled = styled(`div`)`
	gap: 16px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px 0 20px 0;
	width: 100%;
	text-align: center;
`;

export const FooterLinksContainerMStyled = styled(`div`)`
	gap: 16px;
	display: flex;
	flex-direction: column;
	padding-bottom: 12px;
`;

export const FooterTextLinksContainerStyled = styled.div`
	display: flex;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		flex-direction: column;
		gap: 38px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		flex-direction: column;
		gap: 38px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		flex-direction: row;
		gap: 38px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		flex-direction: row;
		gap: 76px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		flex-direction: row;
		gap: 76px;
	}
`;
